import {createRouter, createWebHistory} from 'vue-router';
import auth from '@/commons/authService';
import routerDemo from './routerDemo.js';
import routerPage from './routerPage.js';
import commonFn from '@/commons/commonFunction.js';
import popupUtil from '@/commons/popupUtil.js';
import routerDashboard from './routerDashboard.js';
import routerReport from './routerReport.js';
import routerDictionary from './routerDI.js';
import routerCash from './routerCash.js';
import routerDeposit from './routerDeposit.js';
import routerAsset from './routerAsset.js';
import routerLedger from './routerLedger.js';
import routerTicket from './routerTicket.js';
import routerFptConnect from './routerFptConnect.js';
import routerSystem from './routerSystem.js';
import routerSummary from './routerSummary.js';
import routerBusinessOption from './routerBusinessOption.js';
import routerInitialBalance from './routerInitialBalance.js';
import routerDigitalSign from './routerDigitalSign.js';
import routerEtreasury from './routerEtreasury.js';
const routes = [
  {
    path: '',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: {
      // anonymous: true
    },
    children: [
      // default home
      ...routerDashboard,
      ...routerDictionary,
      ...routerDemo,
      ...routerReport,
      ...routerCash,
      ...routerDeposit,
      ...routerAsset,
      ...routerLedger,
      ...routerTicket,
      ...routerFptConnect,
      ...routerSystem,
      ...routerDeposit,
      ...routerAsset,
      ...routerLedger,
      ...routerSummary,
      ...routerBusinessOption,
      ...routerInitialBalance,
      ...routerDigitalSign,
      ...routerEtreasury,
    ],
  },
  ...routerPage,
  {
    // Redirect to 404 page, if no match found
    path: '/:pathMatch(.*)*',
    component: () => import(/* webpackChunkName:'pages'*/ '@/pages/404.vue'),
    meta: {
      anonymous: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach(() => {
  commonFn.unmask();
});

router.beforeEach((toRouter, from, next) => {
  // khi chuyển router sẽ show maskloading cho người dùng biết xử lý
  // do tình huông tải file js chậm
  // trong after sẽ ẩn mask loading đi
  // Tạm thời dùng loading global, sau này có thể làm kiểu thanh line chạy ngay dưới address bar sau
  commonFn.mask();
  window._cacheTitlePage = [];

  // trang không authen
  if (toRouter.meta.anonymous) {
    next();
    return;
  }

  console.log(toRouter.path);

  // kiểm tra authen -> fail redirect login
  if (!auth.isAuthenticated()) {
    // auth.login(toRouter.path);
    // Thực hiện logout khỏi trương trình thay vì login khi check authen không thành công (nvthinh 19.04.2024)
    commonFn.logoff();
    return;
  }

  // commonFn.checkPermissionDVC(toRouter);

  // check theo quá hạn license, show thông báo và logout luôn
  if (commonFn.checkRouterExpiredDate()) {
    commonFn.checkWarningExpired();
    commonFn.unmask();
    return;
  }

  // check theo quyền hạn vai trò
  // + Nếu là đường dẫn mặc định thì check xem có quyền ko,
  //   nếu ko có quyền thì redirect đến màn hình Getting stated
  const isValid = commonFn.checkPermissionByRoute(toRouter);

  if (!isValid) {
    if (toRouter?.redirectedFrom?.meta?.defaultHomePath) {
      router.push('/initial-information-declaration');
    } else {
      location.href = '/403';
    }
  }

  // default
  next();
});

export default router;
